import type { CelestialBody, BodyTier } from '@/_types/celestial-body'
import type { ListSection } from '@/_types/scene'

/**
 * The order tiers appear in the list view, with the section heading and caption
 * shown for each. Hidden bodies (easter eggs) never appear here.
 */
const tierSections: readonly { tier: BodyTier; label: string; caption: string }[] = [
  { tier: 'sun', label: 'The Platform', caption: 'The core leasing product' },
  { tier: 'inner', label: 'Core', caption: 'The backend and the dashboard' },
  { tier: 'mid', label: 'Build & Content', caption: 'Sites, forms, and media' },
  { tier: 'outer', label: 'Infrastructure & AI', caption: 'Delivery, storage, and intelligence' },
  { tier: 'distant', label: 'Developer & Tools', caption: 'Docs and standalone tools' },
]

/**
 * Group the celestial bodies into labelled list sections by tier, preserving tier
 * order and dropping any hidden bodies. Empty sections are omitted.
 *
 * @param {readonly CelestialBody[]} bodies - The full set of bodies.
 * @returns {ListSection[]} The non-empty list sections in display order.
 */
export function buildListSections(bodies: readonly CelestialBody[]): ListSection[] {
  const sections: ListSection[] = []
  for (const section of tierSections) {
    const matching = bodies.filter((body) => !body.isHidden && body.tier === section.tier)
    if (matching.length === 0) {
      continue
    }
    sections.push({ label: section.label, caption: section.caption, bodies: matching })
  }
  return sections
}
